import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import deleteIcon from '../../../assets/images/delete-icon.svg';
import ConfirmModal from '../../../components/ConfirmModal';
import { RouteNameEnum } from '../../../enums/routeName';
import { ServiceNameEnum } from '../../../enums/serviceName';
import useServices from '../../../hooks/useServices';
import { AxiosService } from '../../../utils/axiosService';

interface DeleteEventModalProps {
  eventId: number;
  isOpen: boolean;
  handleClose: () => void;
}
const DeleteEventModal: React.FC<DeleteEventModalProps> = (props: DeleteEventModalProps) => {
  const { isOpen, handleClose, eventId } = props;
  const navigate = useNavigate();

  const { service: deleteEventService } = useServices(ServiceNameEnum.event.delete);

  const deleteEvent = async (): Promise<void> => {
    const params = { id: eventId };
    const { data, error } = await deleteEventService.delete({ params });
    if (data) {
      handleClose();
      toast.success('Event deleted successfully');
      navigate(RouteNameEnum.event.index);
    } else if (error) {
      const errorResponse = AxiosService.getErrorResponse(error);
      toast.error(errorResponse?.message);
    }
  };

  return (
    <ConfirmModal
      isOpen={isOpen}
      handleClose={handleClose}
      handleSubmit={deleteEvent}
      subTitle="Are you sure you want to delete this event?"
      imageUrl={deleteIcon}
    />
  );
};

export default DeleteEventModal;
